import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { domainsErrorMessageBuilder } from '../../../utils/common-utils';

import Typography from 'fuse-ui/components/Typography';

const styles = ( theme ) => ( {
    errorText: {
        color: theme.palette.error.dark,
    },
    list: {
        listStyle: 'none'
    },
    unorderedList: {
        marginTop: theme.spacing.unit,
        padding: 0,
    }
} );

const DomainManagementBulkDomainsError = ( { classes, domainActionType, domainList, errorType } ) => {
    return (
        <React.Fragment>
            <Typography
                className={classes.errorText}
                variant="overline"
            >
                {domainsErrorMessageBuilder( domainActionType, errorType )}
            </Typography>
            <ul className={classes.unorderedList}>
                {
                    domainList.map( ( domain,index ) => (
                        <li
                            className={classes.list}
                            key={`${errorType}-${domain}-${index}`}
                        >
                            <Typography
                                className={classes.errorText}
                                variant="caption"
                            >
                                {domain}
                            </Typography>
                        </li>
                    ) )
                }
            </ul>
        </React.Fragment>
    );
};

DomainManagementBulkDomainsError.propTypes = {
    classes: PropTypes.object,
    domainActionType: PropTypes.string.isRequired,
    domainList: PropTypes.array.isRequired,
    errorType: PropTypes.string.isRequired,
};

export default withStyles( styles )( DomainManagementBulkDomainsError );
